<template>
  <div
    :class="`tw-grid xl:tw-grid-cols-4 tw-gap-x-${horizontalGap} tw-gap-y-${verticalGap}`"
  >
    <AddressSubField
      v-model="currentValue.address1"
      :label="$t('settings__address_address_1')"
      :class="{
        'tw-col-span-2': withAddress2,
        'tw-col-span-4': !withAddress2,
      }"
      :input-class="inputClass"
      :label-class="labelClass"
      name="address_address1"
      rules="required|max:50"
    />

    <AddressSubField
      v-if="withAddress2"
      v-model="currentValue.address2"
      :input-class="inputClass"
      :label="$t('settings__address_address_2')"
      :label-class="labelClass"
      class="tw-col-span-2"
      name="address_address2"
      rules="max:50"
    />

    <AddressSubField
      v-model="currentValue.city"
      class="tw-col-span-2"
      name="address_city"
      :input-class="inputClass"
      :label="$t('settings__address_city')"
      :label-class="labelClass"
      rules="required"
    />

    <AddressSubField
      v-model="currentValue.state"
      :input-class="inputClass"
      :label="$t('settings__address_state')"
      :label-class="labelClass"
      name="address_state"
      rules="required|max:2"
      type="state"
    />

    <AddressSubField
      v-model="currentValue.zip"
      :input-class="inputClass"
      :label="$t('settings__address_zip_code')"
      :label-class="labelClass"
      name="address_zip"
      rules="required|digits:5"
    />
  </div>
</template>

<script>
import AddressSubField from './AddressSubField.vue'

export default {
  components: {
    AddressSubField,
  },
  props: {
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
    horizontalGap: {
      default: 10,
      type: [Number, String],
      required: false,
      validator: (value) => !isNaN(parseInt(value)),
    },
    inputClass: {
      default: '',
      required: false,
      type: String,
    },
    labelClass: {
      default: '',
      required: false,
      type: String,
    },
    value: {
      default: () => {},
      type: Object,
      required: true,
    },
    verticalGap: {
      default: 10,
      type: [Number, String],
      required: false,
      validator: (value) => !isNaN(parseInt(value)),
    },
    withAddress2: {
      default: true,
      type: Boolean,
      required: false,
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
